import {
  EDIT_LINK_PREVIEW_META_DATA,
  EDIT_UPDATED_RESULTS,
  MAKE_LINK_PREVIEW_CALL,
  MAKE_LINK_PREVIEW_CALL_ERROR,
  MAKE_LINK_PREVIEW_CALL_SUCCESS,
  SET_ACTIVE_LINK_PREVIEW_TAB,
  TOGGLE_MARKETING_SIGN_UP_MODAL,
  SET_SEO_AI_META_TAGS,
  TOGGLE_AI_MODAL,
  GENERATE_SEO_TAGS,
  GENERATE_SEO_TAGS_SUCCESS,
  GENERATE_SEO_TAGS_ERROR,
  TOGGLE_MISSING_TAGS_ALERT,
  GET_IMAGE_LAYOUTS,
  GET_IMAGE_LAYOUTS_SUCCESS,
  GET_IMAGE_LAYOUTS_FAIL,
  TOGGLE_IMAGE_LAYOUT_MODAL,
  SET_MODAL_SELECTED_LAYOUT,
  SET_MODAL_STEP,
  GET_ORGANIZATION_IMAGE_DESIGNS,
  GET_ORGANIZATION_IMAGE_DESIGNS_SUCCESS,
  GET_ORGANIZATION_IMAGE_DESIGNS_FAIL,
  SET_SELECTED_DESIGN,
  SET_SELECTED_DESIGN_TAB_SWITCH,
  SET_MODAL_IS_DESIGN_MODE,
  CREATE_DESIGN,
  CREATE_DESIGN_SUCCESS,
  CREATE_DESIGN_ERROR,
  CLEAR_DESIGN_ERROR,
  UPDATE_MODAL_FORM_FIELD,
  RESET_MODAL_FORM_FIELDS,
  SET_SELECTED_DESIGN_LOADING,
  TOGGLE_CHOOSE_IMAGE_MODAL
} from '../actionTypes';

const initialState = {
  form: {
    url: '',
    title: '',
    description: '',
    image: ''
  },
  results: null,
  newResults: null,
  updatedResults: null,
  isSubmitting: false,
  error: null,
  success: null,
  loading: false,
  showCaptcha: false,
  showSignUpModal: false,
  showMissingTagsAlert: false,
  metaTags: {
    title: '',
    description: '',
    image: '',
    url: '',
    type: ''
  },
  seoAiMetaTags: {
    aiModalOpen: false,
    loading: false,
    error: {
      message: '',
      error: ''
    },
    information: {
      title: '',
      description: '',
      extraContext: ''
    }
  },
  activeTab: 'facebook',
  imageLayouts: {
    loading: false,
    error: null,
    layouts: [],
  },
  imageDesigns: {
    loading: false,
    error: null,
    designs: [],
  },
  imageLayoutModal: {
    open: false,
    loading: false,
    error: null,
    step: 1,
    selectedLayout: null,
    isDesignMode: true,
    formFields: {
      title: '',
      subtitle: '',
      imageUrl: '',
      ctaText: '',
      name: '',
      color: '#FFFFFF'
    }
  },
  chooseImageModal: {
    open: false,
  },
  selectedDesign: {
    design: null,
    tabSwitch: false,
    loading: false,
    error: null,
    pagination: {
      currentPage: 1,
      totalPages: 0,
      hasNextPage: false,
      hasPreviousPage: false
    }
  }
}

const linkPreview = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_LINK_PREVIEW_META_DATA:
      return {
        ...state,
        form: {
          ...state.form,
          [action.name]: action.value
        },
        metaTags: {
          ...state.metaTags,
          [action.name]: action.value
        }
      };
      return newState;
    case EDIT_UPDATED_RESULTS:
      return {
        ...state,
        results: {
          ...action.payload
        },
        updatedResults: {
          ...action.payload
        }
      };
    case SET_ACTIVE_LINK_PREVIEW_TAB:
      return {
        ...state,
        activeTab: action.tab
      };
    case MAKE_LINK_PREVIEW_CALL:
      return {
        ...state,
        loading: true
      };
    case MAKE_LINK_PREVIEW_CALL_SUCCESS:
      return {
        ...state,
        loading: false,
        results: action.results
      };
    case MAKE_LINK_PREVIEW_CALL_ERROR:
      return {
        ...state,
        loading: false,
        error: action.err
      };
    case TOGGLE_MARKETING_SIGN_UP_MODAL:
      return {
        ...state,
        showSignUpModal: action.open
      };
    case TOGGLE_AI_MODAL:
      return {
        ...state,
        seoAiMetaTags: {
          ...state.seoAiMetaTags,
          aiModalOpen: action.open
        }
      };
    case GENERATE_SEO_TAGS:
      return {
        ...state,
        loading: true,
        seoAiMetaTags: {
          ...state.seoAiMetaTags,
          loading: true
        }
      };
    case GENERATE_SEO_TAGS_SUCCESS:
      return {
        ...state,
        loading: false,
        results: {
          ...state.results,
          hybridGraph: {
            ...state.results.hybridGraph,
            ...action.payload
          },
          openGraph: {
            ...state.results.openGraph,
            ...action.payload
          },
          htmlInferred: {
            ...state.results.htmlInferred,
            ...action.payload
          }
        },
        seoAiMetaTags: {
          ...state.seoAiMetaTags,
          loading: false,
          information: action.payload
        }
      };
    case GENERATE_SEO_TAGS_ERROR:
      return {
        ...state,
        loading: false,
        seoAiMetaTags: {
          ...state.seoAiMetaTags,
          loading: false,
          error: action.payload
        }
      };
    case SET_SEO_AI_META_TAGS:
      return {
        ...state,
        seoAiMetaTags: {
          ...state.seoAiMetaTags,
          ...action.payload
        }
      };
    case TOGGLE_MISSING_TAGS_ALERT:
      return {
        ...state,
        showMissingTagsAlert: action.open
      };
    case GET_IMAGE_LAYOUTS:
      return {
        ...state,
        imageTemplates: {
          ...state.imageTemplates,
          loading: true
        }
      };
    case GET_IMAGE_LAYOUTS_SUCCESS:
      return {
        ...state,
        imageLayouts: {
          ...state.imageTemplates,
          loading: false,
          layouts: action.results
        }
      };
    case GET_IMAGE_LAYOUTS_FAIL:
      return {
        ...state,
        imageTemplates: {
          ...state.imageTemplates,
          loading: false,
          error: action.payload
        }
      };
    case TOGGLE_IMAGE_LAYOUT_MODAL:
      return {
        ...state,
        imageLayoutModal: {
          ...state.imageLayoutModal,
          open: action.open
        }
      };
    case TOGGLE_CHOOSE_IMAGE_MODAL:
      return {
        ...state,
        chooseImageModal: {
          ...state.chooseImageModal,
          open: action.open
        }
      };
    case CREATE_DESIGN:
      return {
        ...state,
        imageLayoutModal: {
          ...state.imageLayoutModal,
          loading: true,
          error: null
        }
      };
    case CREATE_DESIGN_SUCCESS:
      return {
        ...state,
        imageLayoutModal: {
          ...state.imageLayoutModal,
          loading: false,
          open: false,
          error: null
        },
        imageDesigns: {
          ...state.imageDesigns,
          designs: [...state.imageDesigns.designs, action.results]
        }
      };
    case CREATE_DESIGN_ERROR:
      return {
        ...state,
        imageLayoutModal: {
          ...state.imageLayoutModal,
          loading: false,
          error: action.payload
        }
      };
    case CLEAR_DESIGN_ERROR:
      return {
        ...state,
        imageLayoutModal: {
          ...state.imageLayoutModal,
          error: null
        }
      };
    case SET_MODAL_SELECTED_LAYOUT:
      return {
        ...state,
        imageLayoutModal: {
          ...state.imageLayoutModal,
          selectedLayout: action.layout,
          error: null
        }
      };
    case SET_MODAL_STEP:
      return {
        ...state,
        imageLayoutModal: {
          ...state.imageLayoutModal,
          step: action.step,
          error: null
        }
      };
    case SET_MODAL_IS_DESIGN_MODE:
      return {
        ...state,
        imageLayoutModal: {
          ...state.imageLayoutModal,
          isDesignMode: action.isDesignMode
        }
      };
    case 'UPDATE_MODAL_FORM_FIELD':
      return {
        ...state,
        imageLayoutModal: {
          ...state.imageLayoutModal,
          formFields: {
            ...state.imageLayoutModal.formFields,
            [action.fieldName]: action.value
          }
        }
      };
    case 'RESET_MODAL_FORM_FIELDS':
      return {
        ...state,
        imageLayoutModal: {
          ...state.imageLayoutModal,
          formFields: {
            title: '',
            subtitle: '',
            imageUrl: '',
            ctaText: '',
            name: '',
            color: '#000000'
          },
          error: null
        }
      };
    case GET_ORGANIZATION_IMAGE_DESIGNS:
      return {
        ...state,
        imageDesigns: {
          ...state.imageDesigns,
          loading: true
        }
      };
    case GET_ORGANIZATION_IMAGE_DESIGNS_SUCCESS:
      return {
        ...state,
        imageDesigns: {
          ...state.imageDesigns,
          loading: false,
          designs: action.results
        }
      };
    case GET_ORGANIZATION_IMAGE_DESIGNS_FAIL:
      return {
        ...state,
        imageDesigns: {
          ...state.imageDesigns,
          loading: false,
          error: action.payload
        }
      };
    case SET_SELECTED_DESIGN:
      return {
        ...state,
        selectedDesign: {
          ...state.selectedDesign,
          design: action.design,
          ...(state.selectedDesign.loading ? {} : { tabSwitch: true })
        }
      };
    case SET_SELECTED_DESIGN_LOADING:
      return {
        ...state,
        selectedDesign: {
          ...state.selectedDesign,
          loading: action.loading,
          ...(action.loading ? { error: null } : {})
        }
      };
    case SET_SELECTED_DESIGN_TAB_SWITCH:
      return {
        ...state,
        selectedDesign: {
          ...state.selectedDesign,
          tabSwitch: action.payload,
          ...(action.payload === false ? { loading: false } : {})
        }
      };
    default:
      return state;
  }
}

export default linkPreview;
